/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} True_Clear_Dog_LeapInputs */

const en_true_clear_dog_leap = /** @type {(inputs: True_Clear_Dog_LeapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

const de_true_clear_dog_leap = /** @type {(inputs: True_Clear_Dog_LeapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ausgewählt`)
};

/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {True_Clear_Dog_LeapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const true_clear_dog_leap = /** @type {((inputs: True_Clear_Dog_LeapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<True_Clear_Dog_LeapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_true_clear_dog_leap(inputs)
	return de_true_clear_dog_leap(inputs)
});